import * as Popover from '@radix-ui/react-popover';
import { Bell } from 'lucide-react';
import { useState } from 'react';

import { useNotificationInbox, useNotificationUnreadCount } from '@/hooks/useNotifications';
import { NotificationInboxPanel } from './NotificationInboxPanel';

export function NotificationBell() {
  const [open, setOpen] = useState(false);
  const { data: countData } = useNotificationUnreadCount();
  const { data: inboxData } = useNotificationInbox(open);

  const unreadCount = inboxData?.unreadCount ?? countData?.unreadCount ?? 0;

  return (
    <Popover.Root open={open} onOpenChange={setOpen}>
      <Popover.Trigger asChild>
        <button
          className="relative p-2.5 rounded-lg text-zinc-500 dark:text-zinc-400
                     hover:bg-zinc-100 dark:hover:bg-zinc-700
                     focus:outline-hidden focus:ring-2 focus:ring-zinc-300
                     transition-colors"
          title="Notifications"
          aria-label={unreadCount > 0 ? `Notifications (${unreadCount} unread)` : 'Notifications'}
          data-testid="notification-bell"
        >
          <Bell className="h-5 w-5" />
          {unreadCount > 0 && (
            <span
              className="absolute top-1.5 right-1.5 flex items-center justify-center
                         min-w-[16px] h-4 px-1 text-[10px] font-bold
                         text-white bg-red-500 rounded-full"
              aria-hidden="true"
            >
              {unreadCount > 99 ? '99+' : unreadCount}
            </span>
          )}
        </button>
      </Popover.Trigger>

      <Popover.Portal>
        <Popover.Content
          className="bg-white dark:bg-zinc-800 rounded-lg shadow-lg
                     border border-zinc-200 dark:border-zinc-700
                     z-50 animate-in fade-in-0 zoom-in-95"
          sideOffset={8}
          align="end"
        >
          <NotificationInboxPanel
            items={inboxData?.items ?? []}
            unreadCount={inboxData?.unreadCount ?? unreadCount}
            onClose={() => setOpen(false)}
          />
        </Popover.Content>
      </Popover.Portal>
    </Popover.Root>
  );
}
